<template>
  <div class="container pb-50" style="margin-top: 7px;">
    <TransactionFilters @filtersChanged="fetchFilteredTransaction"/>
    <div class="bg-block rounded p-12 shadow-primaryBlock relative">
      <div class="mb-8 flex flex-wrap items-center col-gap-10">
        <div class="text-xl font-bold text-text leading-tight mr-auto">{{ $t('title') }}</div>
        <LinkWIcon :text="$t('searchLabel')" @click="toggleSearch">
          <template #icon>
            <IconSearch/>
          </template>
        </LinkWIcon>
        <TransactionsSorting @filtersChanged="fetchFilteredTransaction"/>
        <TransactionsDisplaySettings
            v-bind="transactionsDisplaySettings"
            @change="handleDisplaySettingsChange($event)"/>
        <TransitionCollapseHeight>
          <div class="w-full" v-if="filters.showSearch">
            <div class="mt-8">
              <BaseInput v-model="searchQuery"
                         :debounce="250"
                         :placeholder="$t('searchPlaceholder')"/>
            </div>
          </div>
        </TransitionCollapseHeight>
      </div>
      <TransactionList class="mb-9"
                       :transactions-by-date="transactionsByDate"
                       :transactions="transactions.data"
                       :dirty="transactions.dirty"
                       :sort-by="transactionsSortBy"
                       :sort-type="transactionsSortType"
                       :currency-display="displaySettings.currencyDisplay"
                       @update-data="getFilteredTransactions"
                       @edit="edit_transaction=$event"/>
      <TransactionEditModalProvider :transaction="edit_transaction"
                                    :position="'absolute'"
                                    @finished="getFilteredTransactions"
                                    @close="edit_transaction = null"/>
      <div class="flex items-center bg-bg-to-block-gradient rounded-b
                  -mx-12 -mb-12 lg:-m-12 lg:mt-0
                  px-8 pt-10 pb-10 lg:p-12 lg:pt-15 lg:pb-15"
           v-show="!!Object.keys(transactionsByDate).length">
        <Pagination class="lg:-ml-1"
                    :pagination="pagination"
                    @page="changePage($event)"/>
        <PaginationShowMore :pagination="pagination"
                            @click.native="changePage(pagination.current_page+1,true)"/>
        <PaginationShowAll :pagination="pagination"
                           @click.native="getAllFilteredTransactions"/>
        <TransactionsTotal class="ml-auto"
                           v-if="!!transactions.total_data && !!transactions.total_data.total"
                           :totals="transactions.total_data"/>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import TransactionFilters from '@/components/cabinet/Money/Transactions/TransactionFilters.vue';
import TransactionList from '@/components/cabinet/Money/Transactions/TransactionList.vue';
import TransactionsTotal from '@/components/cabinet/Money/Transactions/TransactionsTotal.vue';
import Pagination from '@/components/UI/Pagination/Pagination.vue';
import PaginationShowMore from "@/components/UI/Pagination/PaginationShowMore";
import TransactionsSorting from "@/components/cabinet/Money/Transactions/TransactionsSorting";
import TransactionEditModalProvider
  from "@/components/common/Transaction/TransactionEditModal/TransactionEditModalProvider";
import IconSearch from "@/components/icons/IconSearch";
import TransitionCollapseHeight from "@/components/transitions/TransitionCollapseHeight";
import BaseInput from "@/components/UI/BaseInput/BaseInput";
import LinkWIcon from "@/components/UI/LinkWIcon";
import PaginationShowAll from "@/components/UI/Pagination/PaginationShowAll";
import TransactionsDisplaySettings
  from "@/components/cabinet/Money/Transactions/TransactionsDisplaySettings/TransactionsDisplaySettings";

export default {
  name: "TheTransactions",
  components: {
    TransactionsDisplaySettings,
    PaginationShowAll,
    LinkWIcon,
    BaseInput,
    TransitionCollapseHeight,
    IconSearch,
    TransactionEditModalProvider,
    PaginationShowMore,
    TransactionFilters, TransactionsSorting, TransactionList, TransactionsTotal, Pagination,
  },
  data() {
    return {
      edit_transaction: null,
      showSearchInput: false,
      debounceSearch: null,
      displaySettings: {
        currencyDisplay: 'default'
      }
    }
  },
  computed: {
    ...mapState('space/transactions', ['transactions', 'filters', 'pagination']),
    ...mapGetters('space/transactions', ['transactionsByDate']),
    transactionsDisplaySettings() {
      return {...this.displaySettings}
    },
    transactionsSortBy() {
      return this.filters.sort_by;
    },
    transactionsSortType() {
      return this.filters.sort_type;
    },
    searchQuery: {
      get() {
        return this.filters.keyword
      },
      set(value) {
        this.setFilterByName({name: 'keyword', value: value})
        this.fetchFilteredTransaction()
      }
    }
  },
  methods: {
    ...mapActions('space/transactions', ['getFilteredTransactions', 'getAllFilteredTransactions', 'updateTransaction', 'removeTransaction']),
    ...mapActions('space/transfers', ['updateTransfer', 'removeTransfer']),
    ...mapMutations('space/transactions', ['toggleSearch', 'setFilterByName', 'setPage', 'clearFilters', 'resetPagination']),
    fetchFilteredTransaction() {
      this.resetPagination();
      this.getFilteredTransactions();
    },
    handleDisplaySettingsChange({name, val}) {
      this.displaySettings[name] = val;
    },
    remove(data) {
      if (!!data.transfer_id) {
        this.removeTransfer(data.transfer_id).then(res => {
          if (res.body.success) {
            this.$toasted.success('Операция удалена');
            this.getFilteredTransactions();
            this.confirm_delete = false;
          } else {
            this.$toasted.error('Произошла ошибка <br> Попробуйте еще раз')
          }
        })
      } else {
        this.removeTransaction(data.id).then(res => {
          if (res.body.success) {
            this.$toasted.success('Операция удалена');
            this.getFilteredTransactions();
            this.confirm_delete = false;
          } else {
            this.$toasted.error('Произошла ошибка <br> Попробуйте еще раз')
          }
        })
      }
    },
    update_transaction(data) {
      this.saving_transaction = true;
      this.updateTransaction(data).then(res => {
        if (res.body.success) {
          this.$toasted.success('Операция изменена');
          this.$emit('update-data')
          this.edit_transaction = null;
          this.saving_transaction = false;
        } else {
          this.$toasted.error('Произошла ошибка <br> Попробуйте еще раз')
          this.saving_transaction = false;
        }
      })
    },
    update_transfer(data) {
      this.saving_transfer = true;
      this.updateTransfer(data).then(res => {
        if (res.body.success) {
          this.$toasted.success('Операция изменена');
          this.$emit('update-data')
          this.edit_transfer = null;
          this.saving_transfer = false;
        } else {
          this.$toasted.error('Произошла ошибка <br> Попробуйте еще раз')
          this.saving_transfer = false;
        }
      })
    },
    changePage(num, showMore = false) {
      this.setPage(num);
      this.getFilteredTransactions(showMore);
    }
  },
  mounted() {
    this.$store.dispatch('space/accounts/getAccounts');
    this.$store.dispatch('space/accounts/getAccountGroups');
    this.$store.dispatch('space/expenses/getExpenses');
    this.$store.dispatch('space/expenses/getExpenseGroups');
    this.$store.dispatch('space/incomes/getIncomes');
    this.$store.dispatch('space/tags/getTags');
    this.$store.dispatch('space/contractors/getContractors');
    this.$store.dispatch('space/fetchSpaceStartAt');
    if (!!this.filters.date_range.start) {
      this.getFilteredTransactions();
    }
  },
  watch: {
    'filters.showSearch': {
      handler(open) {
        if (!open) {
          this.setFilterByName({name: 'keyword', value: null})
          this.getFilteredTransactions();
        }
      }
    }
  },
  i18n: {
    messages: {
      en: {
        title: 'Transaction history',
        searchLabel: 'Search',
        searchPlaceholder: 'You can search by comment, amount, tag or business partner'
      },
      ru: {
        title: 'История операций по счетам',
        searchLabel: 'Поиск',
        searchPlaceholder: 'Можете искать по комментарию, сумме, тегу или контрагенту'
      }
    }
  }
}
</script>
